// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NSB5","footer":"styles_footer__YbK16","passCodeTooltip":"styles_passCodeTooltip__2naLB"};